import { render } from "./EmployeeDocuments.vue?vue&type=template&id=38e5ac46&scoped=true"
import script from "./EmployeeDocuments.vue?vue&type=script&lang=js"
export * from "./EmployeeDocuments.vue?vue&type=script&lang=js"

import "./EmployeeDocuments.vue?vue&type=style&index=0&id=38e5ac46&scoped=true&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e5ac46"]])

export default __exports__